import { TECH_STACK } from "@/data/techStack";

// Two rows of technology names gliding in opposite directions. Each row is
// repeated four times: the animation moves it by half, and each half must
// be wider than the screen for the loop to stay seamless.
const ROW_A = TECH_STACK.slice(0, 2).flatMap((g) => g.items);
const ROW_B = TECH_STACK.slice(2).flatMap((g) => g.items);

/** "Our Technology Expertise", as in the redesign mockup. */
export function TechStack() {
  return (
    <section className="dc" style={{ background: "#F5F6F8", color: "#0B1020", padding: "120px 0 128px" }}>
      <div style={{ maxWidth: "1280px", margin: "0 auto", padding: "0 32px" }}>
        <div className="rv" style={{ display: "flex", flexWrap: "wrap", justifyContent: "space-between", alignItems: "flex-end", gap: "32px" }}>
          <div style={{ maxWidth: "720px" }}>
            <div style={{ fontFamily: "'JetBrains Mono', monospace", fontSize: "13px", letterSpacing: ".14em", textTransform: "uppercase", color: "#3A5BEA" }}>Technical Depth</div>
            <h2 style={{ fontFamily: "Sora, sans-serif", fontWeight: "600", fontSize: "clamp(2rem, 3.8vw, 3.2rem)", letterSpacing: "-0.03em", lineHeight: "1.1", margin: "16px 0 0" }}>Our Technology Expertise</h2>
          </div>
          <p style={{ maxWidth: "400px", margin: "0", fontSize: "18px", lineHeight: "1.6", color: "#4A5468" }}>Practical experience across the stack businesses actually build and run on.</p>
        </div>
        <div className="rvl" style={{ height: "1px", background: "#D5DAE3", margin: "48px 0 0" }}></div>
      </div>

      {/* Decorative: the cards below list the same technologies. */}
      <div aria-hidden="true" style={{ marginTop: "48px", display: "flex", flexDirection: "column", gap: "16px" }}>
        <div className="mq">
          <div className="mqt">
            {[...ROW_A, ...ROW_A, ...ROW_A, ...ROW_A].map((t, i) => (
              <span key={i} style={{ flex: "none", marginRight: "16px", padding: "18px 30px", borderRadius: "14px", background: "#fff", border: "1px solid #E3E7EE", fontFamily: "Sora, sans-serif", fontWeight: "500", fontSize: "22px", letterSpacing: "-0.01em", color: "#0B1020", whiteSpace: "nowrap" }}>{t}</span>
            ))}
          </div>
        </div>
        <div className="mq">
          <div className="mqt r">
            {[...ROW_B, ...ROW_B, ...ROW_B, ...ROW_B].map((t, i) => (
              <span key={i} style={{ flex: "none", marginRight: "16px", padding: "18px 30px", borderRadius: "14px", background: "#0B1020", fontFamily: "Sora, sans-serif", fontWeight: "500", fontSize: "22px", letterSpacing: "-0.01em", color: "#E8ECF4", whiteSpace: "nowrap" }}>{t}</span>
            ))}
          </div>
        </div>
      </div>

      <div style={{ maxWidth: "1280px", margin: "64px auto 0", padding: "0 32px", display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))", gap: "20px" }}>
        {TECH_STACK.map((g, idx) => (
          <div key={g.label} className="tcard rv" style={{ background: "#fff", border: "1px solid #E3E7EE", borderRadius: "20px", padding: "30px" }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <h3 style={{ fontFamily: "Sora, sans-serif", fontWeight: "600", fontSize: "20px", margin: "0" }}>{g.label}</h3>
              <span style={{ fontFamily: "'JetBrains Mono', monospace", fontSize: "12px", color: "#6B7488" }}>/{String(idx + 1).padStart(2, "0")}</span>
            </div>
            <ul style={{ listStyle: "none", padding: "0", margin: "22px 0 0", display: "flex", flexDirection: "column", gap: "12px" }}>
              {g.items.map((i) => (
                <li key={i} style={{ display: "flex", alignItems: "center", gap: "10px", fontSize: "16px", color: "#2A3142" }}><span style={{ width: "6px", height: "6px", borderRadius: "2px", background: "#5B7CFA" }}></span>{i}</li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </section>
  );
}
